<template lang="pug">
.addUnit__deviceInfo
  van-nav-bar(
    :title="$t('fallback.title')"
    left-arrow
    @click-left="close"
    @click-right="checkForm")
    van-icon(name="save" slot="right")

  .main.addUnit__protocol
    van-cell-group.addUnit__popup__cell-group
      van-cell.van-cell--value-select(
        :title="$t('fallback.alpha')"
        :value="alpha"
        @click="openSetAlgorithTemp(alpha, 'alpha')")

      van-cell.van-cell--value-select(
        :title="$t('fallback.beta')"
        :value="beta"
        @click="openSetAlgorithTemp(beta, 'beta')")

      van-cell.van-cell--value-select(
        :title="$t('fallback.stoptime')"
        :value="stoptime"
        @click="openSetStopTime(stoptime)")

      van-cell.van-cell--value-select(
        :title="$t('fallback.fanSpeed')"
        :value="fanSpeed"
        @click="openSetFanSpeed(fanSpeed)")

      van-cell.van-cell--value-select(
        :title="$t('fallback.minruntime')"
        :value="minruntime"
        @click="openSetMinRuntime(minruntime)")

      //- van-field(
      //-   type="number"
      //-   name="stoptime"
      //-   v-model="stoptime"
      //-   v-validate="'required|numeric'"
      //-   :data-vv-as="$t('fallback.stoptime')"
      //-   :class="{'error': errors.has('stoptime') }"
      //-   :label="$t('fallback.stoptime')")
      //-   .van-cell-text(slot="button") s

      //- van-field(
      //-   type="number"
      //-   name="minruntime"
      //-   v-model="minruntime"
      //-   v-validate="'required|numeric'"
      //-   :data-vv-as="$t('fallback.minruntime')"
      //-   :class="{'error': errors.has('minruntime') }"
      //-   :label="$t('fallback.minruntime')")
      //-   .van-cell-text(slot="button") m
</template>

<script>
import BluetoothService from '@/services/bluetooth.service';
import { getErrorId } from '@/services/error.service';

export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      alpha: '',
      beta: '',
      stoptime: '',
      minruntime: '',
      fanSpeed: '',
      alphaBetaOptions: [
        { text: '3 ºF - 1.66 ºC', value: 3 },
        { text: '5 ºF - 2.78 ºC', value: 5 },
        { text: '7 ºF - 3.89 ºC', value: 7 },
      ],
      stoptimeOptions: [
        { text: '1 min', value: 60 },
        { text: '2 min', value: 120 },
        { text: '3 min', value: 180 },
        { text: '4 min', value: 240 },
        { text: '5 min', value: 300 },
        { text: '6 min', value: 360 },
        { text: '7 min', value: 420 },
        { text: '8 min', value: 480 },
        { text: '9 min', value: 540 },
        { text: '10 min', value: 600 },
        { text: '11 min', value: 660 },
        { text: '12 min', value: 720 },
        { text: '13 min', value: 780 },
        { text: '14 min', value: 840 },
        { text: '15 min', value: 900 },
        { text: '16 min', value: 960 },
        { text: '17 min', value: 1020 },
        { text: '18 min', value: 1080 },
        { text: '19 min', value: 1140 },
        { text: '20 min', value: 1200 },
        { text: '21 min', value: 1260 },
        { text: '22 min', value: 1320 },
        { text: '23 min', value: 1380 },
        { text: '24 min', value: 1440 },
        { text: '25 min', value: 1500 },
        { text: '26 min', value: 1560 },
        { text: '27 min', value: 1620 },
        { text: '28 min', value: 1680 },
        { text: '29 min', value: 1740 },
        { text: '30 min', value: 1800 },
      ],
      minRuntimeOptions: [
        { text: '5 min', value: 5 },
        { text: '6 min', value: 6 },
        { text: '7 min', value: 7 },
        { text: '8 min', value: 8 },
        { text: '9 min', value: 9 },
        { text: '10 min', value: 10 },
        { text: '11 min', value: 11 },
        { text: '12 min', value: 12 },
        { text: '13 min', value: 13 },
        { text: '14 min', value: 14 },
        { text: '15 min', value: 15 },
        { text: '16 min', value: 16 },
        { text: '17 min', value: 17 },
        { text: '18 min', value: 18 },
        { text: '19 min', value: 19 },
        { text: '20 min', value: 20 },
      ],
      fanSpeedOptions: [
        { text: `${this.$i18n.t('fallback.speed')} 1`, value: 1 },
        { text: `${this.$i18n.t('fallback.speed')} 2`, value: 2 },
        { text: `${this.$i18n.t('fallback.speed')} 3`, value: 3 },
        { text: `${this.$i18n.t('fallback.speed')} 4`, value: 4 },
        { text: `${this.$i18n.t('fallback.speed')} 5`, value: 5 },
        { text: `${this.$i18n.t('fallback.speed')} Auto`, value: 6 },
      ],
    };
  },

  methods: {
    closest(value, options) {
      return options.reduce((a, b) => {
        const aDiff = Math.abs(a.value - value);
        const bDiff = Math.abs(b.value - value);

        if (aDiff === bDiff) {
          return a.value > b.value ? a : b;
        }
        return bDiff < aDiff ? b : a;
      });
    },

    /**
     * Devuelve el texto del algoritmo
     */
    getAlgorithmText(value) {
      const option = this.alphaBetaOptions.find(item => item.value === value);
      return option.text;
    },

    /**
     * Devuelve el valor del algoritmo
     */
    getAlgorithmValue(text) {
      const option = this.alphaBetaOptions.find(item => item.text === text);
      return option.value;
    },

    getStopTimeText(value) {
      let option = this.stoptimeOptions.find(item => item.value === value);

      if (option) option = this.closest(value, this.stoptimeOptions);

      return option.text;
    },

    getStopTimeValue(text) {
      const option = this.stoptimeOptions.find(item => item.text === text);
      return option.value;
    },

    getMinRuntimeText(value) {
      let option = this.minRuntimeOptions.find(item => item.value === value);
      if (option) option = this.closest(value, this.minRuntimeOptions);

      return option.text;
    },

    getMinRuntimeValue(text) {
      const option = this.minRuntimeOptions.find(item => item.text === text);
      return option.value;
    },

    getFanSpeedText(value) {
      const option = this.fanSpeedOptions.find(item => item.value === value);
      return option.text;
    },

    getFanSpeedValue(text) {
      const option = this.fanSpeedOptions.find(item => item.text === text);
      return option.value;
    },

    /**
     * Compruebo si los datos del formulario son válidos
     */
    checkForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.saveProtocol();
        }
      });
    },

    /**
     * Muestra el selector de temperatura
     */
    openSetAlgorithTemp(value, algorithm) {
      const configAlgortihm = {
        title: this.$i18n.t(`fallback.${algorithm}`),
        items: [[this.alphaBetaOptions]],
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configAlgortihm, result => {
        this[algorithm] = this.alphaBetaOptions[result[0].index].text;
      });
    },

    /**
     * Muestra el selector de stoptime
     */
    openSetStopTime(value) {
      const configStopTime = {
        title: this.$i18n.t('fallback.stoptime'),
        items: [[this.stoptimeOptions]],
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configStopTime, result => {
        this.stoptime = this.stoptimeOptions[result[0].index].text;
      });
    },

    /**
     * Muestra el selector de min runtime
     */
    openSetMinRuntime(value) {
      const configMinRuntime = {
        title: this.$i18n.t('fallback.minruntime'),
        items: [[this.minRuntimeOptions]],
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configMinRuntime, result => {
        this.minruntime = this.minRuntimeOptions[result[0].index].text;
      });
    },

    /**
     * Muestra el selector de fan Speed
     */
    openSetFanSpeed(value) {
      const configFanSpeed = {
        title: this.$i18n.t('fallback.fanSpeed'),
        items: [[this.fanSpeedOptions]],
        positiveButtonText: this.$i18n.t('fallback.done'),
        negativeButtonText: this.$i18n.t('fallback.cancel'),
        theme: 'dark',
        displayKey: 'text',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configFanSpeed, result => {
        this.fanSpeed = this.fanSpeedOptions[result[0].index].text;
      });
    },

    /**
     * Guarda los datos
     */
    async saveProtocol() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        // Preparo los datos
        const data = {
          gpioalpha: this.getAlgorithmValue(this.alpha),
          gpiobeta: this.getAlgorithmValue(this.beta),
          gpiostoptime: this.getStopTimeValue(this.stoptime),
          gpiominruntime: this.getMinRuntimeValue(this.minruntime),
          gpiofanspeed: this.getFanSpeedValue(this.fanSpeed),
        };

        console.log(data);

        // Realizo la petición
        await BluetoothService.setExtrainfo(this.device.id, JSON.stringify(data));
        const result = await BluetoothService.getDeviceInfo(this.device.id);

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('fallback.success'),
        });
        this.close(result.extrainfo);
      } catch (error) {
        console.log(error);
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('fallback.error') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Cierra este componente
     */
    close(data) {
      this.$emit('close', data);
    },
  },

  mounted() {
    this.alpha = this.getAlgorithmText(this.device.gpioalpha);
    this.beta = this.getAlgorithmText(this.device.gpiobeta);
    this.stoptime = this.getStopTimeText(this.device.gpiostoptime);
    this.minruntime = this.getMinRuntimeText(this.device.gpiominruntime);
    this.fanSpeed = this.getFanSpeedText(this.device.gpiofanspeed);
  },
};
</script>
